import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation, Scrollbar } from "swiper/modules";

import ConnectAccount from "./steps/ConnectAccount";
import StartEarning from "./steps/StartEarning/StartEarning";
import Welcome from "./steps/Welcome";
import GettingStarted from "./steps/GettingStarted/GettingStarted";
import WatchPromo from "./steps/WatchPromo/WatchPromo";

const OnboardingPage = () => {
  return (
    <Box sx={{ height: "100%" }}>
      <Swiper
        initialSlide={0}
        cssMode={false}
        style={{ height: "100%" }}
        direction="horizontal"
        spaceBetween={16}
        slidesPerView={1}
        loop={false}
        freeMode={false}
        pagination={false}
        scrollbar={false}
        allowTouchMove={false}
        modules={[Navigation, Scrollbar]}
      >
        <SwiperSlide>
          <Welcome />
        </SwiperSlide>

        <SwiperSlide>
          <GettingStarted />
        </SwiperSlide>

        <SwiperSlide>
          <WatchPromo />
        </SwiperSlide>

        <SwiperSlide>
          <ConnectAccount />
        </SwiperSlide>

        <SwiperSlide>
          <StartEarning />
        </SwiperSlide>
      </Swiper>
    </Box>
  );
};

export default OnboardingPage;
